import Vue from 'vue'
import { StylesControl } from 'mapbox-gl-controls'

Vue.prototype.$stylesControl = StylesControl
